var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.3C11.057 6.3 11.5911 6.07875 11.9849 5.68492C12.3788 5.2911 12.6 4.75695 12.6 4.2H14C14.0001 4.66558 13.9073 5.12649 13.727 5.55576C13.5468 5.98503 13.2827 6.37402 12.9502 6.69995C12.6178 7.02589 12.2237 7.28222 11.7909 7.45394C11.3581 7.62566 10.8955 7.70931 10.43 7.7C10.2928 8.37262 9.96087 8.99006 9.47547 9.47547C8.99006 9.96087 8.37262 10.2928 7.7 10.43V11.9L11.2 13.3V14H2.8V13.3L6.3 11.9V10.43C5.62738 10.2928 5.00994 9.96087 4.52453 9.47547C4.03912 8.99006 3.70718 8.37262 3.57 7.7H3.5C2.57174 7.7 1.6815 7.33125 1.02513 6.67487C0.368749 6.0185 0 5.12826 0 4.2H1.4C1.4 4.75695 1.62125 5.2911 2.01508 5.68492C2.4089 6.07875 2.94305 6.3 3.5 6.3V2.8H1.4V4.2H0V1.4H3.5V0H10.5V1.4H14V4.2H12.6V2.8H10.5V6.3Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.c89333cc5e16d00b2a292210e1c152e6.svg";
export { ForwardRef as ReactComponent };